<template>
  <div
    class="flex items-center w-full cell-renderer-item addon-gkmg-port-master-cell-renderer-item"
    :class="[cellBackgroundColor]"
  >
    <div
      class="w-full flex items-center justify-center pm-ag-grid-inner-cell"
      v-if="
        params.value && getValueMapSafely(params).displayType === 'highlight'
      "
    >
      <div>
        <div
          @click="isSyncHighlight = !isSyncHighlight"
          class="highlight-toggle"
          :class="{
            'highlight-toggle--enabled': isSyncHighlight,
            'highlight-toggle--disabled': !isSyncHighlight,
          }"
        ></div>
      </div>
    </div>
    <div class="w-full flex items-center pm-ag-grid-inner-cell">
      <div
        v-if="
          params.value && getValueMapSafely(params).displayType === 'progress'
        "
        :class="
          params.value && getValueMapSafely(params).editable
            ? [classNameCursorPointer]
            : null
        "
      >
        <vs-chip
          class="pm-chip-square-radius progress"
          :color="getProgressDisplayInfo(getValueMapSafely(params)).color"
        >
          <span>{{
            getProgressDisplayInfo(getValueMapSafely(params)).label
          }}</span>
        </vs-chip>
        <span class="progress-time">{{
          getProgressDisplayInfo(getValueMapSafely(params)).time || ""
        }}</span>
      </div>

      <div
        v-if="
          params.value && getValueMapSafely(params).displayType === 'plain-text'
        "
        :class="
          params.value.columnKey === 'name' ||
          (params.value && getValueMapSafely(params).editable)
            ? [classNameCursorPointer]
            : null
        "
      >
        <span>
          {{
            getValueMapSafely(params).itSelf ||
            (getValueMapSafely(params).editable ? "+" : "")
          }}
        </span>
      </div>

      <div
        v-if="
          params.value &&
          getValueMapSafely(params).displayType === 'plain-number'
        "
        :class="
          params.value && getValueMapSafely(params).editable
            ? [classNameCursorPointer]
            : null
        "
      >
        <span>
          {{
            getValueMapSafely(params).itSelf === 0 ||
            getValueMapSafely(params).itSelf
              ? getValueMapSafely(params).itSelf
              : getValueMapSafely(params).editable
              ? "+"
              : ""
          }}
        </span>
      </div>

      <div
        v-if="
          params.value && getValueMapSafely(params).displayType === 'vehicles'
        "
        :class="
          params.value && getValueMapSafely(params).editable
            ? [classNameCursorPointer]
            : null
        "
      >
        <div
          v-if="
            getValueMapSafely(params).itSelf.filter((el) =>
              [vesselToDisplay].includes(el.status),
            ).length > 0
          "
          class="w-full flex items-center justify-start pm-ag-grid-inner-cell"
        >
          <div
            v-for="(equipment, index) in getValueMapSafely(params).itSelf"
            :key="index"
            class="flex items-center pm-ag-grid-inner-cell"
          >
            <vs-chip
              class="pm-chip-square-radius pm-chip-width__equipment"
              v-if="[vesselToDisplay].includes(equipment.status)"
              :color="itemChipColor(equipment)"
              :transparent="itemChipTransparent(equipment.id)"
              :style="itemChipStyle(equipment.id, params.value.columnKey)"
            >
              <span style="padding: 0; margin: 0; font-weight: bold">
                {{ vehiclesMaster.find((el) => el.id === equipment.id).label }}
              </span>
            </vs-chip>
          </div>
        </div>
        <div v-else class="blank-circle-plus-left">+</div>
      </div>

      <div
        v-if="params.value && getValueMapSafely(params).displayType === 'bit'"
        :class="
          params.value && getValueMapSafely(params).editable
            ? [classNameCursorPointer]
            : null
        "
      >
        <span>
          {{
            getValueMapSafely(params).itSelf ||
            (getValueMapSafely(params).editable ? "+" : "")
          }}
        </span>
      </div>

      <div
        v-if="
          params.value &&
          getValueMapSafely(params).displayType === 'boardside_type'
        "
        :class="
          params.value && getValueMapSafely(params).editable
            ? [classNameCursorPointer]
            : null
        "
      >
        <span>
          {{
            getValueMapSafely(params).itSelf &&
            getValueMapSafely(params).itSelf.label
              ? boardsideTypeMasterList.find(
                  (el) =>
                    String(el.saveValue) ===
                    String(getValueMapSafely(params).itSelf.label),
                ).label
              : getValueMapSafely(params).editable
              ? "+"
              : ""
          }}
        </span>
        <feather-icon
          v-if="
            getValueMapSafely(params).itSelf &&
            boardsideTypeMasterList.find(
              (el) =>
                String(el.id) === String(getValueMapSafely(params).itSelf.id),
            ).isAddCircleToLabel
          "
          icon="RefreshCwIcon"
          svgClasses="h-4 w-4"
          class="pm-boardside-type-icon"
        />
      </div>

      <div
        v-if="
          params.value &&
          (getValueMapSafely(params).displayType === 'HH:mm' ||
            getValueMapSafely(params).displayType === 'MM/DD:HH:mm')
        "
        :class="
          params.value && getValueMapSafely(params).editable
            ? [classNameCursorPointer]
            : null
        "
      >
        <span>
          {{
            formattedTime(getValueMapSafely(params).itSelf) ||
            (getValueMapSafely(params).editable ? "+" : "")
          }}
        </span>
      </div>

      <div
        v-if="
          params.value && getValueMapSafely(params).displayType === 'masterMap'
        "
        :class="
          params.value && getValueMapSafely(params).editable
            ? [classNameCursorPointer]
            : null
        "
      >
        <span v-if="params.value.columnKey === 'island_id'">
          {{
            getLabelFromMaster("island_id", getValueMapSafely(params).itSelf) ||
            (getValueMapSafely(params).editable ? "+" : "")
          }}
        </span>
        <span v-if="params.value.columnKey === 'port_id'">
          {{
            getLabelFromMaster("port_id", getValueMapSafely(params).itSelf) ||
            (getValueMapSafely(params).editable ? "+" : "")
          }}
        </span>
        <span v-if="params.value.columnKey === 'quay_id'">
          {{
            getLabelFromMaster("quay_id", getValueMapSafely(params).itSelf) ||
            (getValueMapSafely(params).editable ? "+" : "")
          }}
        </span>
        <span v-if="params.value.columnKey === 'berth_id'">
          {{
            getBerthLabel(getValueMapSafely(params)) ||
            (getValueMapSafely(params).editable ? "+" : "")
          }}
        </span>
      </div>
    </div>

    <div is="style">
      .ag-theme-material .ag-icon-grip:before { display: inline-block; width:
      1.4rem; height: 1.4rem; margin: 0 0 0 10px !important; padding: 0
      !important; vertical-align: top; content : ' '; font-size: 1.8rem;
      background-image: url({{ rowDragIconUrl }}); background-repeat: no-repeat;
      background-size: contain; }
    </div>
  </div>
</template>

<script>
import isObject from "lodash/isObject";
import { createNamespacedHelpers } from "vuex";
const { mapActions, mapState } = createNamespacedHelpers(
  "gkmgPortMasterDestinationWork",
);
const {
  mapState: mapStateOfGkmgPortMaster,
  mapGetters: mapGetterOfGkmgPortMaster,
} = createNamespacedHelpers("gkmgPortMaster");
import moment from "moment-timezone";
import {
  COL_NAME,
  VEHICLES_MASTER,
  VEHICLES_STATUS,
  BOARDSIDE_TYPE_MASTERLIST,
} from "@/config/const.js";
import { isSameTaskVesselNameAndMasterVesselName } from "@/utils/gkmgPortMaster";
const CLICKABLE_CLASS_NAME = "pm-cursor-pointer";

export default {
  name: "CellRendererItem",
  components: {},
  data() {
    return {
      updateBLinkMinutes: 0, // 変更直後の点滅の時間（分）。 0=点滅なし。
      nowValueOf: moment().valueOf(),
      isHighlight: false,
      isReadOnlyDevice: false,
      orderTypeShortNameMap: {
        1: "出",
        2: "入",
      },
      rowDragIconUrl: require("@/assets/images/icons/gkmg-port-master/row_drag.svg"),
      snowWhiteIcon: require(`@/assets/images/icons/port-master/snow_white.svg`),
      rainWhiteIcon: require(`@/assets/images/icons/port-master/rain_white.svg`),
      vesselToDisplay: VEHICLES_STATUS.ORDERED,
      boardsideTypeMasterList: BOARDSIDE_TYPE_MASTERLIST,
    };
  },
  computed: {
    ...mapState({
      masterMap: (state) => state.masterMap,
      selectedTaskId: (state) => state.selectedTaskId,
      selectedColumnKey: (state) => state.selectedColumnKey,
      summaryDialogShowPopup: (state) => state.summaryDialogShowPopup,
    }),
    ...mapStateOfGkmgPortMaster({
      selectedPort: (state) => state.selectedPort,
      vesselsData: (state) => state.vesselsData,
    }),
    ...mapGetterOfGkmgPortMaster(["gkmgPortMasterAuth", "vesselsDataMap"]),
    getValueMapSafely() {
      return (params) => {
        const columnNamesList = COL_NAME.map((el) => el.columnKey);
        if (!columnNamesList.includes(params.value.columnKey)) {
          return "";
        } else if (params && params.value && params.value.valueMap) {
          return params.value.valueMap;
        } else {
          return {};
        }
      };
    },
    getUpdateColor() {
      const self = this;
      return function (changesValue) {
        if (changesValue && self.nowValueOf) {
          // changesValueが存在した時点で、style適用は確定
          const elapsedMinutes = (self.nowValueOf - changesValue) / 1000 / 60;
          if (elapsedMinutes < self.updateBlinkMinutes) {
            // x分以内だったら。Blink
            return "updated-cell-blink";
          }
          return "updated-cell";
        }
        return null;
      };
    },
    getSelectedColor() {
      const selfTaskId =
        this.params &&
        this.params &&
        this.params.value &&
        this.params.value.taskId
          ? this.params.value.taskId
          : "";
      const selfColumnKey =
        this.params &&
        this.params &&
        this.params.value &&
        this.params.value.columnKey
          ? this.params.value.columnKey
          : "";

      if (
        this.summaryDialogShowPopup === true &&
        selfTaskId === this.selectedTaskId
      ) {
        if (
          selfColumnKey === this.selectedColumnKey &&
          !["highlight", "vessel", "caution_note"].includes(selfColumnKey)
        ) {
          return "pm-selected-cell";
        }
        return "pm-selected-row";
      }
      return null;
    },
    canClickNameColumn() {
      const {
        gkmgPortMasterAuth: {
          destinationWorkList: { edit: canEditWorkList = false },
        },
        vesselsDataMap,
        params: {
          data: taskData = null, // destinationWorkTasksMap[date][taskId]( {docData: {vessel_name: string} | undefined} )
        },
      } = this;
      if (canEditWorkList) return true;

      if (!isObject(taskData)) return false;
      if (!taskData.docData) return false;
      if (!taskData.docData.vessel_id) return false;
      const vesselId = taskData.docData.vessel_id;
      const vesselsMaster = vesselsDataMap[vesselId];
      return isSameTaskVesselNameAndMasterVesselName(taskData, vesselsMaster); // 編集権限がある か 船舶名がマスタと同じ時だけクリック可能
    },
    classNameCursorPointerVesselName() {
      if (this.canClickNameColumn) return CLICKABLE_CLASS_NAME;
      return null; // "pm-cursor-pointer" | "null
    },
    classNameCursorPointer() {
      // this.gkmgPortMasterAuthは元はconst.jsのGKMG_AUTH_MASTERを見ているため、必ずdestinationWorkList.editを持つ
      if (this.params.value.columnKey === "name") {
        return this.classNameCursorPointerVesselName;
      }
      const hasEditAuth = this.gkmgPortMasterAuth.destinationWorkList.edit;
      if (!hasEditAuth) {
        return null;
      }

      if (this.isReadOnlyDevice === true) {
        return null;
      }
      return CLICKABLE_CLASS_NAME;
    },

    cellBackgroundColor() {
      const updateColor =
        this.params &&
        this.params.value &&
        this.getUpdateColor(this.params.value.changes);
      const selectedColor = this.getSelectedColor;
      if (selectedColor === "pm-selected-cell") {
        return selectedColor;
      } else if (selectedColor === "pm-selected-row") {
        return selectedColor;
      } else if (updateColor) {
        return updateColor;
      } else if (this.isSyncHighlight === true) {
        return "pm-grouped-row";
      }
      return null;
    },

    isSyncHighlight: {
      get() {
        return (
          this.params && this.params.value && this.params.value.highlight === 1
        );
      },
      async set(val) {
        const highlightValue = val === true ? 1 : 0;

        // 同一行の別の列項目に highlight情報を伝搬。

        for (let key of Object.keys(this.params.node.data)) {
          if (!["id", "docData"].includes(key)) {
            this.params.node.data[key].highlight = highlightValue;
          }
        }

        let updateData = {
          enterprisePort: this.selectedPort,
          taskId: this.params.value.taskId,
          data: {
            highlight: highlightValue,
          },
        };
        // firestoreを更新
        this.updateFirestoreDocument(updateData);

        // agGrid1の対象行に直接更新。
        const newTaskWithName = await this.mergeUpdateDataIntoTaskRecord({
          updateData: updateData,
          vesselsData: this.vesselsData,
        });
        this.params.node.setData(newTaskWithName);
      },
    },
    vehiclesMaster() {
      return VEHICLES_MASTER;
    },
  },
  methods: {
    ...mapActions(["updateFirestoreDocument", "mergeUpdateDataIntoTaskRecord"]),
    getProgressDisplayInfo(progressInfo) {
      /*
       * progressは表示の仕方が特殊なため、専用の関数を作成
       * progressInfo {
       *   itSelf: number (gkmg_pm_settingsのprogressのキー)
       *   progress_time: {
       *     progress_at  : {seconds:timestamp,nanoseconds:timestamp},  // 進捗時間
       *     complete     : {seconds:timestamp,nanoseconds:timestamp},  // 終了時間
       *     suspend_at     : {seconds:timestamp,nanoseconds:timestamp},  // 中止時間
       *   }
       * }
       *
       * gkmg_pm_setting.progress {
       *   1: 開始前
       *   2: 進行中
       *   3: 終了
       *   4: 中止
       * }
       */
      const progressStatusMapper = {
        1: "",
        2: "progress_at",
        3: "complete",
        4: "suspend_at",
      };

      // プログレスは開始前の状態から始まるため、何もデータがない場合は1（開始前）を設定する。
      const DEFAULT_PROGRESS_VALUE = 1;
      const progressValue = progressInfo.itSelf || DEFAULT_PROGRESS_VALUE;

      const presentProgressStatus = progressStatusMapper[progressValue];

      // 画面に表示する進捗時間を計算するhelper
      const calcProgressTime = (
        progressInfo, // {
        //   itSelf: number (gkmg_pm_settingsのprogressのキー)
        //   progress_time: {
        //     progress_at  : {seconds:timestamp,nanoseconds:timestamp},  // 進捗時間
        //     complete     : {seconds:timestamp,nanoseconds:timestamp},  // 終了時間
        //     suspend_at     : {seconds:timestamp,nanoseconds:timestamp},  // 中止時間
        //   }
        // }
        progressStatus, // string
      ) => {
        const isProgress = progressStatus === "progress_at";
        const isComplete = progressStatus === "complete";
        const isSuspend = progressStatus === "suspend_at";
        if (isProgress && progressInfo.progress_time.progress_at.seconds) {
          // 進行中
          return moment(progressInfo.progress_time.progress_at.seconds * 1000)
            .local()
            .format("HH:mm");
        } else if (isComplete && progressInfo.progress_time.complete.seconds) {
          // 終了
          return moment(progressInfo.progress_time.complete.seconds * 1000)
            .local()
            .format("HH:mm");
        } else if (isSuspend && progressInfo.progress_time.suspend_at.seconds) {
          // 中止
          return moment(progressInfo.progress_time.suspend_at.seconds * 1000)
            .local()
            .format("HH:mm");
        }
        return "";
      };

      if (!progressInfo.progress_time) {
        return {
          label: this.getLabelFromMaster("progress", progressValue),
          color: this.getColorFromMaster("progress", progressValue),
          time: "",
        };
      } else {
        const progressTime = calcProgressTime(
          progressInfo,
          presentProgressStatus,
        );
        return {
          label: this.getLabelFromMaster("progress", progressValue),
          color: this.getColorFromMaster("progress", progressValue),
          time: progressTime,
        };
      }
    },

    formattedTime(dateValue) {
      if (!dateValue) {
        return "";
      } else {
        return moment(dateValue * 1000)
          .local()
          .format("HH:mm");
      }
    },
    /**
     * 表示用の名称をマスタから取得する
     */
    getLabelFromMaster(columnName, id) {
      /*
       * gkmg_pm_settingsにマスタを持つ列項目について、表示する値を取得する
       */

      // island_id, port_id, quay_idに対応するラベルについては、gkmg_pm_vesselsにArray<map>でデータを保持している。
      if (columnName === "island_id") {
        const island = this.masterMap["islands"].find(
          (el) => String(el.id) === String(id),
        );
        if (!island) return "";
        return island.label;
      }

      if (columnName === "port_id") {
        const port = this.masterMap["ports"].find(
          (el) => String(el.id) === String(id),
        );
        if (!port) return "";
        return port.label;
      }

      if (columnName === "quay_id") {
        const quay = this.masterMap["quays"].find(
          (el) => String(el.id) === String(id),
        );
        if (!quay) return "";
        return quay.label;
      }

      // progressはgkmg_pm_tasksにmapでデータを保持している
      if (columnName === "progress") {
        return this.masterMap[columnName][id];
      }

      return "";
    },
    /**
     * 表示用の色をマスタから取得する
     */
    getColorFromMaster(columnName, id) {
      return COL_NAME.find((el) => el.columnKey === columnName).color[id];
    },
    /**
     * バース名を取得する
     */
    getBerthLabel(param) {
      // berthについては、バースIDをそのまま表示する仕様となった。
      return param.itSelf;
    },
    itemChipColor(unit) {
      let itemColorCode = null;
      if (unit.status === 2) {
        itemColorCode = "#081e29";
      } else if (unit.status === 3) {
        const borderColor = "#20678F";
        itemColorCode = borderColor;
        return itemColorCode;
      }
    },
    itemChipTransparent(unit) {
      let isTransparent = false;
      if (unit.status === 2) {
        isTransparent = true;
      }
      return isTransparent;
    },
    itemChipStyle(unit) {
      const isTransparent = this.itemChipTransparent(unit);
      const borderColor = "#20678F";

      return {
        border: "0.1rem solid " + borderColor,
        "box-sizing": "border-box",
        "background-color": (isTransparent ? "#c4c4c4" : null) + " !important",
      };
    },
  },
  mounted() {
    setInterval(() => {
      this.nowValueOf = moment().valueOf();
    }, 10 * 60 * 1000);
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/port-master/_variables.scss";

.addon-gkmg-port-master-cell-renderer-item {
  .pm-ag-grid-inner-cell {
    height: 100%;
    padding: 0 auto;
  }

  .cell-renderer-item {
    height: 100%;
    padding-left: 0.2rem;
  }

  .updated-cell {
    background-color: #768227;
    border: none;
  }

  .updated-cell-blink {
    animation: blinkAnime 2s infinite alternate;
    border: 1px solid #768227;
  }
  &.pm-grouped-row {
    background-color: #65676a;
    height: 100%;
  }
  .pm-selected-row {
    background-color: $pm-gray;
  }
  .pm-selected-cell {
    background-color: #333333;
    border: 0.15rem solid $pm-blue;
    box-sizing: border-box;
  }

  .pm-literal-margin {
    margin: 0 0.1rem;
  }
  .pm-chip-square-radius {
    border-radius: 0.2rem;
  }

  .pm-cursor-pointer {
    cursor: pointer;
  }

  .highlight-toggle {
    $cell_mergin: calc(0.1rem);
    $slider_width: calc(1.4rem);
    $slider_height: calc(#{$slider_width} / 2);
    $cell_size: calc(#{$slider_height} - #{$cell_mergin} * 2);

    cursor: pointer;
    width: $slider_width;
    height: $slider_height;
    border-radius: calc(#{$slider_height} / 2);

    &:before {
      content: "";
      position: absolute;
      top: calc(50% - #{$cell_mergin} - #{$cell_size} / 2);
      height: $cell_size;
      width: $cell_size;
      border-radius: 50%;
      margin: $cell_mergin;
    }

    &--enabled {
      background-color: #959596;
      &:before {
        margin-left: calc(#{$slider_width} - #{$cell_mergin} - #{$cell_size});
        background-color: $pm-white;
      }
    }

    &--disabled {
      background-color: #727272;
      &:before {
        background-color: $pm-mouse-gray;
      }
    }
  }

  @keyframes blinkAnime {
    0% {
      background-color: rgba(226, 229, 108, 0.8);
    }
    100% {
      background-color: rgba(226, 229, 108, 0.2);
    }
  }
  .progress {
    width: 50px;
    height: 30px;
    margin: 6px 0px 6px 0px;
  }
  .progress-time {
    width: 50px;
    height: 30px;
    margin: 6px 12px 6px 0px;
    padding: 10px;
    display: flex;
    align-items: center;
  }
}
</style>
